import './App.css';
import TuitionCalculator from './components/tuition-calculator';
import { TuitionProvider } from './context/TuitionContext';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <TuitionProvider>
          <TuitionCalculator/>  
        </TuitionProvider>
      </header>
      
    </div>
  );
}

export default App;
